import { Component, Input, OnChanges, signal } from '@angular/core';
import { IMPORTS } from './_imports';

@Component({
    selector: 'dashboard-item',
    templateUrl: './dashboard-item.component.html',
    styleUrl: './dashboard-item.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class DashboardItemComponent implements OnChanges {
    // #region [signals]
    $counter = signal(null as string);
    $counterLabel = signal(null as string);
    // #endregion

    // #region [Input/Output]
    @Input() _counter: string;
    @Input() _counterLabel: string;
    // #endregion

    constructor() { }

    ngOnChanges() {
        this.$counter.set(this._counter);
        this.$counterLabel.set(this._counterLabel);
    }

    // #region [===== private methods =====]
    // #endregion
}
